import { RemoteMenuBySlug } from '../../../../data/usecases/menus/menu-by-slug/remote-menu-by-slug'
import { makeAxiosHttpClient } from '../../../factories/http/axios-http-client-factory'

export const makeRemoteMenuFooter = () => {
  return new RemoteMenuBySlug('/menus/slug/rodape', makeAxiosHttpClient())
}
